<div class="d-flex flex-row justify-content-center">
  <input #otp *ngFor="let otpInput of otpInputList; let i = index" type="number"
    [ngClass]="incompleteOtp || invalidOtp ? 'otp-box-error' : 'otp-box'" class="otp-box mr-2"
    (keyup)="onKey($event, i)">
</div>
